// Centralized Spotify playlist links per team (NFL + College)
// Values are Spotify EMBED URLs.

export const playlistLinks = {
  // NFL
  'Arizona Cardinals': 'https://open.spotify.com/embed/playlist/5pNTOTDpualjmIJbTEjjjU',
  'Atlanta Falcons': 'https://open.spotify.com/embed/playlist/6lv1bcAyFR6eF6I5jEhHx1',
  'Baltimore Ravens': 'https://open.spotify.com/embed/playlist/3uGPYbBtuSGp4wIQiGKFCi',
  'Buffalo Bills': 'https://open.spotify.com/embed/playlist/5LvRMjAj9zyCRoR8tlJou7',
  'Carolina Panthers': 'https://open.spotify.com/embed/playlist/4baREtLxFnsxuOCVArGxsx',
  'Chicago Bears': 'https://open.spotify.com/embed/playlist/6MYiMMPXFMlYSgwO1qZ9x4',
  'Cincinnati Bengals': 'https://open.spotify.com/embed/playlist/62AdIMrSW7v4inUlIGpv0C',
  'Cleveland Browns': 'https://open.spotify.com/embed/playlist/0YS3m6X0oY9UhpYiNxluNf',
  'Dallas Cowboys': 'https://open.spotify.com/embed/playlist/5iCpftlYib4RXuXfWIXK2n',
  'Denver Broncos': 'https://open.spotify.com/embed/playlist/7nIaGMj3Fpu2OOSuS7P1ee',
  'Detroit Lions': 'https://open.spotify.com/embed/playlist/1mvsqHvoWmtiiLYymcC5BW',
  'Green Bay Packers': 'https://open.spotify.com/embed/playlist/1Gq2ormdUyK8jgZGSqJpZB',
  'Houston Texans': 'https://open.spotify.com/embed/playlist/0dX8eEE42AKycSDhy1DNTH',
  'Indianapolis Colts': 'https://open.spotify.com/embed/playlist/1uWKfeJPpXUTUs0qUJAPUg',
  'Jacksonville Jaguars': 'https://open.spotify.com/embed/playlist/74HcBGnxzxnXvjH7iKVqao',
  'Kansas City Chiefs': 'https://open.spotify.com/embed/playlist/4R929MgKc946h8Xo8ThbUx',
  'Las Vegas Raiders': 'https://open.spotify.com/embed/playlist/28wLzGJfTRubRh3LGT7vU7',
  'Los Angeles Chargers': undefined, // Not provided; will fall back to default
  'Los Angeles Rams': 'https://open.spotify.com/embed/playlist/403hSLCzYNkYcBvQd19Mlv',
  'Miami Dolphins': 'https://open.spotify.com/embed/playlist/2vcYGpYiOEsLlduoKtBBmF',
  'Minnesota Vikings': 'https://open.spotify.com/embed/playlist/0aryjHmaIbQmXBVBjshDoX',
  'New England Patriots': 'https://open.spotify.com/embed/playlist/1ldhnCETGnfOUerWnsWLm8',
  'New Orleans Saints': 'https://open.spotify.com/embed/playlist/4SyuGePAsKzGz4HcLMSJQK',
  'New York Giants': 'https://open.spotify.com/embed/playlist/6Ci3EEPBiUlG0o6TCsfDKh',
  'New York Jets': 'https://open.spotify.com/embed/playlist/4VF6U04EUeMYr7Kjfq3thz',
  'Philadelphia Eagles': 'https://open.spotify.com/embed/playlist/2CbxsAl8tK6byhKSpspflO',
  'Pittsburgh Steelers': 'https://open.spotify.com/embed/playlist/2K47IZA3UKs9nAzqo0R3gC',
  'San Francisco 49ers': 'https://open.spotify.com/embed/playlist/69BpNfsY5FJ1R17hZXd1Kp',
  'Seattle Seahawks': 'https://open.spotify.com/embed/playlist/6tkyGsbGJaHhbdTNP31Q1q',
  'Tampa Bay Buccaneers': 'https://open.spotify.com/embed/playlist/7nBZLQI4r3GFXXOUWdZfWl',
  'Tennessee Titans': 'https://open.spotify.com/embed/playlist/5WyDe1yMG8bNrtQtxWPNDy',
  'Washington Commanders': 'https://open.spotify.com/embed/playlist/0czHJEeDlVSyCGlYEZ7REz',

  // NFL aliases provided by client
  'Vegas Raiders': 'https://open.spotify.com/embed/playlist/28wLzGJfTRubRh3LGT7vU7',
  'San Fran': 'https://open.spotify.com/embed/playlist/69BpNfsY5FJ1R17hZXd1Kp',
  'New Orleans': 'https://open.spotify.com/embed/playlist/4SyuGePAsKzGz4HcLMSJQK',
  'Tampa Bay': 'https://open.spotify.com/embed/playlist/7nBZLQI4r3GFXXOUWdZfWl',
  'Philly Eagles': 'https://open.spotify.com/embed/playlist/2CbxsAl8tK6byhKSpspflO',
  'New England Pats': 'https://open.spotify.com/embed/playlist/1ldhnCETGnfOUerWnsWLm8',
  'Washington Redskins': 'https://open.spotify.com/embed/playlist/0czHJEeDlVSyCGlYEZ7REz',

  // SEC
  'Texas': 'https://open.spotify.com/embed/playlist/31LtHJO7ceUfiGMTNQHR87',
  'Texas Longhorns': 'https://open.spotify.com/embed/playlist/31LtHJO7ceUfiGMTNQHR87',
  'Mississippi State': 'https://open.spotify.com/embed/playlist/516BjvVVxf38ZMLk1nMSPX',
  'Mississippi State Bulldogs': 'https://open.spotify.com/embed/playlist/516BjvVVxf38ZMLk1nMSPX',
  'Ole Miss': 'https://open.spotify.com/embed/playlist/62SlDWeeE8DXRz16S0Jom3',
  'Ole Miss Rebels': 'https://open.spotify.com/embed/playlist/62SlDWeeE8DXRz16S0Jom3',
  'Missouri': 'https://open.spotify.com/embed/playlist/206KllohRqXEVsFwd4mpuk',
  'Missouri Tigers': 'https://open.spotify.com/embed/playlist/206KllohRqXEVsFwd4mpuk',
  'LSU': 'https://open.spotify.com/embed/playlist/7kuwhM4eWQyNMZsYVTZBkH',
  'LSU Tigers': 'https://open.spotify.com/embed/playlist/7kuwhM4eWQyNMZsYVTZBkH',
  'Kentucky': 'https://open.spotify.com/embed/playlist/6xkD5ie9l8Yt0WUuwLYCkb',
  'Kentucky Wildcats': 'https://open.spotify.com/embed/playlist/6xkD5ie9l8Yt0WUuwLYCkb',
  'Texas A&M': 'https://open.spotify.com/embed/playlist/59J662OkVfSMJSodyzq5wn',
  'Texas A&M Aggies': 'https://open.spotify.com/embed/playlist/59J662OkVfSMJSodyzq5wn',
  'Tennessee': 'https://open.spotify.com/embed/playlist/1EAK0cT4iRqukfFx0xSQZ0',
  'Tennessee Volunteers': 'https://open.spotify.com/embed/playlist/1EAK0cT4iRqukfFx0xSQZ0',
  'Vanderbilt': 'https://open.spotify.com/embed/playlist/3ZZM9GSwc4s7lOmZenFsbc',
  'Vanderbilt Commodores': 'https://open.spotify.com/embed/playlist/3ZZM9GSwc4s7lOmZenFsbc',
  'South Carolina': 'https://open.spotify.com/embed/playlist/1NJM6IM0vGubO6oTsp4uqM',
  'South Carolina Gamecocks': 'https://open.spotify.com/embed/playlist/1NJM6IM0vGubO6oTsp4uqM',
  'Florida': 'https://open.spotify.com/embed/playlist/3WUwDDjF07Q1AzrTpGIL93',
  'Florida Gators': 'https://open.spotify.com/embed/playlist/3WUwDDjF07Q1AzrTpGIL93',
  'Auburn': 'https://open.spotify.com/embed/playlist/5VkI8jxsuNKtB2HsKN4r4X',
  'Auburn Tigers': 'https://open.spotify.com/embed/playlist/5VkI8jxsuNKtB2HsKN4r4X',
  'Georgia': 'https://open.spotify.com/embed/playlist/0JfH6FrQ2IVRf1bAfhzSNF',
  'Georgia Bulldogs': 'https://open.spotify.com/embed/playlist/0JfH6FrQ2IVRf1bAfhzSNF',
  'Arkansas': 'https://open.spotify.com/embed/playlist/7DsvKgVCmRgds1aatcHU67',
  'Arkansas Razorbacks': 'https://open.spotify.com/embed/playlist/7DsvKgVCmRgds1aatcHU67',
  'Alabama': 'https://open.spotify.com/embed/playlist/7o9NACi0OULhVBVpPW0kx0',
  'Alabama Crimson Tide': 'https://open.spotify.com/embed/playlist/7o9NACi0OULhVBVpPW0kx0',
  'Oklahoma': 'https://open.spotify.com/embed/playlist/5x5srMVfzV8ENQunh7iXR5',
  'Oklahoma Sooners': 'https://open.spotify.com/embed/playlist/5x5srMVfzV8ENQunh7iXR5',

  // ACC
  'SMU': 'https://open.spotify.com/embed/playlist/38qSj4EtQeWsmNftmT35zK',
  'SMU Mustangs': 'https://open.spotify.com/embed/playlist/38qSj4EtQeWsmNftmT35zK',
  'California': 'https://open.spotify.com/embed/playlist/48Pk6Kr2tNInwlMP1HWNhr',
  'California Golden Bears': 'https://open.spotify.com/embed/playlist/48Pk6Kr2tNInwlMP1HWNhr',
  'Stanford': 'https://open.spotify.com/embed/playlist/6KHJ45UkkSBNQe9w3AaLIR',
  'Stanford Cardinal': 'https://open.spotify.com/embed/playlist/6KHJ45UkkSBNQe9w3AaLIR',
  'Wake Forest': 'https://open.spotify.com/embed/playlist/4WNsSur2pMou5HFWdjbWvd',
  'Wake Forest Demon Deacons': 'https://open.spotify.com/embed/playlist/4WNsSur2pMou5HFWdjbWvd',
  'Virginia': 'https://open.spotify.com/embed/playlist/3CuIW2e3i2XpFE5ihCUuIp',
  'Virginia Cavaliers': 'https://open.spotify.com/embed/playlist/3CuIW2e3i2XpFE5ihCUuIp',
  'Syracuse': 'https://open.spotify.com/embed/playlist/7DHbhB1dlVYMJFCh6NoCaI',
  'Syracuse Orange': 'https://open.spotify.com/embed/playlist/7DHbhB1dlVYMJFCh6NoCaI',
  'Pittsburgh': 'https://open.spotify.com/embed/playlist/1IrOyyDpq82fE8idSRvHyW',
  'Pittsburgh Panthers': 'https://open.spotify.com/embed/playlist/1IrOyyDpq82fE8idSRvHyW',
  'NC State': 'https://open.spotify.com/embed/playlist/4MNgIsgVvXVmvDM15Ajw5F',
  'NC State Wolfpack': 'https://open.spotify.com/embed/playlist/4MNgIsgVvXVmvDM15Ajw5F',
  'North Carolina': 'https://open.spotify.com/embed/playlist/0FOuHESixRAS9WxnTI5v55',
  'North Carolina Tar Heels': 'https://open.spotify.com/embed/playlist/0FOuHESixRAS9WxnTI5v55',
  'Miami': 'https://open.spotify.com/embed/playlist/1MZSevhZQ9oQifTcih39dU',
  'Miami Hurricanes': 'https://open.spotify.com/embed/playlist/1MZSevhZQ9oQifTcih39dU',
  'Louisville': 'https://open.spotify.com/embed/playlist/4La6mEgZU9kukRby2aYfch',
  'Louisville Cardinals': 'https://open.spotify.com/embed/playlist/4La6mEgZU9kukRby2aYfch',
  'Georgia Tech': 'https://open.spotify.com/embed/playlist/1FnRurf5i3XuNE6m7kNSLg',
  'Georgia Tech Yellow Jackets': 'https://open.spotify.com/embed/playlist/1FnRurf5i3XuNE6m7kNSLg',
  'Boston College': 'https://open.spotify.com/embed/playlist/5Pz9s4PpFzLU01NMna6cYV',
  'Boston College Eagles': 'https://open.spotify.com/embed/playlist/5Pz9s4PpFzLU01NMna6cYV',
  'Duke': 'https://open.spotify.com/embed/playlist/3i1jYy977N4VWIHWAB5RBJ',
  'Duke Blue Devils': 'https://open.spotify.com/embed/playlist/3i1jYy977N4VWIHWAB5RBJ',
  'Florida State': 'https://open.spotify.com/embed/playlist/0RhT1sRsfRwzfcinHS5b4N',
  'Florida State Seminoles': 'https://open.spotify.com/embed/playlist/0RhT1sRsfRwzfcinHS5b4N',
  'Clemson': 'https://open.spotify.com/embed/playlist/0CABWOHHH0d0CYk0i5TW8W',
  'Clemson Tigers': 'https://open.spotify.com/embed/playlist/0CABWOHHH0d0CYk0i5TW8W',
  'Virginia Tech': 'https://open.spotify.com/embed/playlist/2XTnNltC4zDLzdvC5TqMVB',
  'Virginia Tech Hokies': 'https://open.spotify.com/embed/playlist/2XTnNltC4zDLzdvC5TqMVB',

  // Big Ten
  'Oregon': 'https://open.spotify.com/embed/playlist/3ThOKBoiu5as3tRsqP0HoE',
  'Oregon Ducks': 'https://open.spotify.com/embed/playlist/3ThOKBoiu5as3tRsqP0HoE',
  'Ohio State': 'https://open.spotify.com/embed/playlist/1LmLCAiIu0vyKmvix3jgHI',
  'Ohio State Buckeyes': 'https://open.spotify.com/embed/playlist/1LmLCAiIu0vyKmvix3jgHI',
  'UCLA': 'https://open.spotify.com/embed/playlist/6YE27J1zvnWEtEOuKDSCu4',
  'UCLA Bruins': 'https://open.spotify.com/embed/playlist/6YE27J1zvnWEtEOuKDSCu4',
  'USC': 'https://open.spotify.com/embed/playlist/3GxyoLK43CD4nZG6Che1Je',
  'USC Trojans': 'https://open.spotify.com/embed/playlist/3GxyoLK43CD4nZG6Che1Je',
  'Washington': 'https://open.spotify.com/embed/playlist/70eV4hZHq5q3h5MkRMDQbs',
  'Washington Huskies': 'https://open.spotify.com/embed/playlist/70eV4hZHq5q3h5MkRMDQbs',
  'Northwestern': 'https://open.spotify.com/embed/playlist/6NKvrFkt66iiUOTbzsh9du',
  'Northwestern Wildcats': 'https://open.spotify.com/embed/playlist/6NKvrFkt66iiUOTbzsh9du',
  'Illinois': 'https://open.spotify.com/embed/playlist/1SWT0TjlOhuD5XvXlrRMbv',
  'Illinois Fighting Illini': 'https://open.spotify.com/embed/playlist/1SWT0TjlOhuD5XvXlrRMbv',
  'Purdue': 'https://open.spotify.com/embed/playlist/7ltTHAFfZQEq0asFyOrUx0',
  'Purdue Boilermakers': 'https://open.spotify.com/embed/playlist/7ltTHAFfZQEq0asFyOrUx0',
  'Rutgers': 'https://open.spotify.com/embed/playlist/4v9OuaxxO0WCjCQ6WQfKwO',
  'Rutgers Scarlet Knights': 'https://open.spotify.com/embed/playlist/4v9OuaxxO0WCjCQ6WQfKwO',
  'Maryland': 'https://open.spotify.com/embed/playlist/3CmJrmSjshsDEVYLmmcfEi',
  'Maryland Terrapins': 'https://open.spotify.com/embed/playlist/3CmJrmSjshsDEVYLmmcfEi',
  'Indiana': 'https://open.spotify.com/embed/playlist/3bV1wZPkZqk6qO2MEMMsH7',
  'Indiana Hoosiers': 'https://open.spotify.com/embed/playlist/3bV1wZPkZqk6qO2MEMMsH7',
  'Iowa': 'https://open.spotify.com/embed/playlist/0VCf9wrmgpB8M4oMzmmcCQ',
  'Iowa Hawkeyes': 'https://open.spotify.com/embed/playlist/0VCf9wrmgpB8M4oMzmmcCQ',
  'Minnesota': 'https://open.spotify.com/embed/playlist/76edCnD9Fd2orm7K039MVy',
  'Minnesota Golden Gophers': 'https://open.spotify.com/embed/playlist/76edCnD9Fd2orm7K039MVy',
  'Nebraska': 'https://open.spotify.com/embed/playlist/3bwbzmjr6x4e2YrzbYCuPo',
  'Nebraska Cornhuskers': 'https://open.spotify.com/embed/playlist/3bwbzmjr6x4e2YrzbYCuPo',
  'Michigan State': 'https://open.spotify.com/embed/playlist/3S9IdUQfVl8IIQMbjoMyL6',
  'Michigan State Spartans': 'https://open.spotify.com/embed/playlist/3S9IdUQfVl8IIQMbjoMyL6',
  'Penn State': 'https://open.spotify.com/embed/playlist/3WxKELyRElWJvugdYTJBe6',
  'Penn State Nittany Lions': 'https://open.spotify.com/embed/playlist/3WxKELyRElWJvugdYTJBe6',
  'Michigan': 'https://open.spotify.com/embed/playlist/5NPoZQCnRFSJ8AH3qO0Xq8',
  'Michigan Wolverines': 'https://open.spotify.com/embed/playlist/5NPoZQCnRFSJ8AH3qO0Xq8',
  'Wisconsin': 'https://open.spotify.com/embed/playlist/4gHGnouIwBFmp8bOEpvOHu',
  'Wisconsin Badgers': 'https://open.spotify.com/embed/playlist/4gHGnouIwBFmp8bOEpvOHu',

  // Big 12
  'Oklahoma State': 'https://open.spotify.com/embed/playlist/1yCx86p0un2S5V5AAGkLKU',
  'Oklahoma State Cowboys': 'https://open.spotify.com/embed/playlist/1yCx86p0un2S5V5AAGkLKU',
  'Colorado': 'https://open.spotify.com/embed/playlist/2eNVgsuvB2Ra3260nr6xPq',
  'Colorado Buffaloes': 'https://open.spotify.com/embed/playlist/2eNVgsuvB2Ra3260nr6xPq',
  'Utah': 'https://open.spotify.com/embed/playlist/0U5Dv1vsLuufTaQzFnUFlB',
  'Utah Utes': 'https://open.spotify.com/embed/playlist/0U5Dv1vsLuufTaQzFnUFlB',
  'Arizona State': 'https://open.spotify.com/embed/playlist/7LjimyBFkMsz83KOScmTqA',
  'Arizona State Sun Devils': 'https://open.spotify.com/embed/playlist/7LjimyBFkMsz83KOScmTqA',
  'Arizona': 'https://open.spotify.com/embed/playlist/6YTMK4mPYjZkqVfAtKVnhc',
  'Arizona Wildcats': 'https://open.spotify.com/embed/playlist/6YTMK4mPYjZkqVfAtKVnhc',
  'BYU': 'https://open.spotify.com/embed/playlist/34HrU5x3bXbgzPtzxC8vBa',
  'BYU Cougars': 'https://open.spotify.com/embed/playlist/34HrU5x3bXbgzPtzxC8vBa',
  'UCF': 'https://open.spotify.com/embed/playlist/4zANBjw40BOIBtCwdyxDuI',
  'UCF Knights': 'https://open.spotify.com/embed/playlist/4zANBjw40BOIBtCwdyxDuI',
  'Baylor': 'https://open.spotify.com/embed/playlist/31mkPypK354HiRo5CibLl7',
  'Baylor Bears': 'https://open.spotify.com/embed/playlist/31mkPypK354HiRo5CibLl7',
  'Cincinnati': 'https://open.spotify.com/embed/playlist/1pfsaPHP9c2DgxonTgAqDs',
  'Cincinnati Bearcats': 'https://open.spotify.com/embed/playlist/1pfsaPHP9c2DgxonTgAqDs',
  'Houston': 'https://open.spotify.com/embed/playlist/6tYKVqazDLz9rm54HpyyuU',
  'Houston Cougars': 'https://open.spotify.com/embed/playlist/6tYKVqazDLz9rm54HpyyuU',
  'TCU': 'https://open.spotify.com/embed/playlist/4BBUvI6LBwA3DSyyGRE6qn',
  'TCU Horned Frogs': 'https://open.spotify.com/embed/playlist/4BBUvI6LBwA3DSyyGRE6qn',
  'Iowa State': 'https://open.spotify.com/embed/playlist/5cXEQOVNwlBogaAb5zTV3S',
  'Iowa State Cyclones': 'https://open.spotify.com/embed/playlist/5cXEQOVNwlBogaAb5zTV3S',
  'Kansas': 'https://open.spotify.com/embed/playlist/0VDoAiD9o2z2UbogMOdLrM',
  'Kansas Jayhawks': 'https://open.spotify.com/embed/playlist/0VDoAiD9o2z2UbogMOdLrM',
  'Texas Tech': 'https://open.spotify.com/embed/playlist/0qTecUxPWaHvBUVy7yH7Z4',
  'Texas Tech Red Raiders': 'https://open.spotify.com/embed/playlist/0qTecUxPWaHvBUVy7yH7Z4',
  'West Virginia': 'https://open.spotify.com/embed/playlist/15nnJdseaExEF45wAcTV71',
  'West Virginia Mountaineers': 'https://open.spotify.com/embed/playlist/15nnJdseaExEF45wAcTV71',
  'Kansas State': 'https://open.spotify.com/embed/playlist/2SyfTHKOT45pWNZUZqRA3g',
  'Kansas State Wildcats': 'https://open.spotify.com/embed/playlist/2SyfTHKOT45pWNZUZqRA3g',

  // Others / Independents / Pac-2
  'Washington State': 'https://open.spotify.com/embed/playlist/1oaSGJmrF7sUPmw6b3DVv7',
  'Washington State Cougars': 'https://open.spotify.com/embed/playlist/1oaSGJmrF7sUPmw6b3DVv7',
  'Oregon State': 'https://open.spotify.com/embed/playlist/4Rck6YdVWV30V5vfVHN2u0',
  'Oregon State Beavers': 'https://open.spotify.com/embed/playlist/4Rck6YdVWV30V5vfVHN2u0',
  'Notre Dame': 'https://open.spotify.com/embed/playlist/4en8wM0WZ0HRZQYYJcQTCR',
  'Notre Dame Fighting Irish': 'https://open.spotify.com/embed/playlist/4en8wM0WZ0HRZQYYJcQTCR',
  'Navy': 'https://open.spotify.com/embed/playlist/7GzVr8wS1YbG98Jr5H5SEZ',
  'Navy Midshipmen': 'https://open.spotify.com/embed/playlist/7GzVr8wS1YbG98Jr5H5SEZ',
  'Army': 'https://open.spotify.com/embed/playlist/74vCdKoYH0MpTCrGQnWB1P',
  'Army Black Knights': 'https://open.spotify.com/embed/playlist/74vCdKoYH0MpTCrGQnWB1P',

  // MLB
  'San Francisco Giants': 'https://open.spotify.com/embed/playlist/2GSIzvpq4xL75RcJv6Ppvf',
  'LA Dodgers': 'https://open.spotify.com/embed/playlist/4mldZSeUl6Lc91T38cj50c',
  'Los Angeles Dodgers': 'https://open.spotify.com/embed/playlist/4mldZSeUl6Lc91T38cj50c',
  'San Diego Padres': 'https://open.spotify.com/embed/playlist/32E9dba21lqhxaL2HtNpO1',
  'NY Mets': 'https://open.spotify.com/embed/playlist/12ai2mIu3wRIHtohSp9WyB',
  'New York Mets': 'https://open.spotify.com/embed/playlist/12ai2mIu3wRIHtohSp9WyB',
  'Colorado Rockies': 'https://open.spotify.com/embed/playlist/4OP5p6H4JITOgOEo24QxhX',
  'Arizona Diamondbacks': 'https://open.spotify.com/embed/playlist/5ADUi82hMVoXutd2bBLDrF',
  'Washington Nationals': 'https://open.spotify.com/embed/playlist/74O4x4eQGYaCg5pcnJe0RT',
  'Philadelphia Phillies': 'https://open.spotify.com/embed/playlist/2HgRtpAvvZ2TEi1ETvcSOZ',
  'Atlanta Braves': 'https://open.spotify.com/embed/playlist/6nlHm5zLQQPBZebVrpzF32',
  'Miami Marlins': 'https://open.spotify.com/embed/playlist/4OB5MQmJhpxtzMPA8gij8p',
  'Pittsburgh Pirates': 'https://open.spotify.com/embed/playlist/42aie9zOQRt2o8zzzdNR5w',
  'St Louis Cardinals': 'https://open.spotify.com/embed/playlist/41xlWV3MpidFOWQcRfjkrX',
  'St. Louis Cardinals': 'https://open.spotify.com/embed/playlist/41xlWV3MpidFOWQcRfjkrX',
  'Milwaukee Brewers': 'https://open.spotify.com/embed/playlist/5wJqcbOIHTcxOS2DpRh8A9',
  'Cincinnati Reds': 'https://open.spotify.com/embed/playlist/3Y6u4gMV94IwZUUXmIdu6x',
  'NY Yankees': 'https://open.spotify.com/embed/playlist/7xTIGScuMylOOa2cSzOaLu',
  'New York Yankees': 'https://open.spotify.com/embed/playlist/7xTIGScuMylOOa2cSzOaLu',
  'Chicago Cubs': 'https://open.spotify.com/embed/playlist/3mYRQxuchhOKzF8KvZXvpl',
  'Texas Rangers': 'https://open.spotify.com/embed/playlist/5rfyG346irz53ASwJs98FH',
  'Seattle Mariners': 'https://open.spotify.com/embed/playlist/6oIpChMq5wo9rVtUno1ec1',
  'Boston Red Sox': 'https://open.spotify.com/embed/playlist/44uDvuTZj2pPLev7WUslat',
  'Los Angeles Angels': 'https://open.spotify.com/embed/playlist/4lzcLTyYtY4a1TzeQSkFpI',
  'Houston Astros': 'https://open.spotify.com/embed/playlist/1qgda2C3ZrFUcCyh7F02it',
  'Oakland Athletics': 'https://open.spotify.com/embed/playlist/3rvOloPxlK0lqA88PxnFIO',
  'Toronto Blue Jays': 'https://open.spotify.com/embed/playlist/6OxewiRHuGjFz2XhDnhNBZ',
  'Tampa Bay Rays': 'https://open.spotify.com/embed/playlist/6LzY9w2TRLeIgIb82mFlQt',
  'Cleveland Guardians': 'https://open.spotify.com/embed/playlist/0w2EH7ZZaIQ5wt2g7g029a',
  'Baltimore Orioles': 'https://open.spotify.com/embed/playlist/55y6ZEX17QrTsRPNWpStf2',
  'Minnesota Twins': 'https://open.spotify.com/embed/playlist/7JgiJrxBOu9yITKglnLqIC',
  'KC Royals': 'https://open.spotify.com/embed/playlist/67eqdEarG9QENEUakTqKql',
  'Kansas City Royals': 'https://open.spotify.com/embed/playlist/67eqdEarG9QENEUakTqKql',
  'Detroit Tigers': 'https://open.spotify.com/embed/playlist/2VMlVBsmZgBV5t7gUCqKLu',
  'Chicago White Sox': 'https://open.spotify.com/embed/playlist/1PLtsLDhnTjMXYQ74JNBIe',

  // NHL
  'Philadelphia Flyers': 'https://open.spotify.com/embed/playlist/0YH32aSpTZX3IYs4o3GSKp',
  'Winnipeg Jets': 'https://open.spotify.com/embed/playlist/6h2Kj1ZIm8xkL3ssAgdsw1',
  'Washington Capitals': 'https://open.spotify.com/embed/playlist/5kR0eZ8jBbFHfmX10HOi2S',
  'Washington Capitols': 'https://open.spotify.com/embed/playlist/5kR0eZ8jBbFHfmX10HOi2S',
  'Vegas Golden Knights': 'https://open.spotify.com/embed/playlist/4jGDfahSGZs6cSVU24yP9o',
  'Vancouver Canucks': 'https://open.spotify.com/embed/playlist/70rWCASwnkf5I4kl46yLb8',
  'Toronto Maple Leafs': 'https://open.spotify.com/embed/playlist/6S0Rq7ztGLBkIsieOfFfSA',
  'Tampa Bay Lightning': 'https://open.spotify.com/embed/playlist/6Z8tdmAD4T03jyb880EsI5',
  'St Louis Blues': 'https://open.spotify.com/embed/playlist/0TDSd0mcYewUUIaj80ss45',
  'St. Louis Blues': 'https://open.spotify.com/embed/playlist/0TDSd0mcYewUUIaj80ss45',
  'Seattle Kraken': 'https://open.spotify.com/embed/playlist/2ac1gZo1mQXHnk1YFKRfGx',
  'New York Rangers': 'https://open.spotify.com/embed/playlist/4nW8oXrhacqhi9JENyxl85',
  'San Jose Sharks': 'https://open.spotify.com/embed/playlist/64BMuv4G75TVK2pBMJNNXA',
  'Pittsburgh Penguins': 'https://open.spotify.com/embed/playlist/4vHgU6ogcq5tNmCJK1hg6X',
  'Ottawa Senators': 'https://open.spotify.com/embed/playlist/0B6TrFtywI3S87YEYSIi12',
  'Chicago Blackhawks': 'https://open.spotify.com/embed/playlist/0y9sMgoZMVIclcHwuVCchn',
  'New York Islanders': 'https://open.spotify.com/embed/playlist/6s2GCUj2VmNQFWcLyYDKQa',
  'New Jersey Devils': 'https://open.spotify.com/embed/playlist/4GZeBHthh2JZEccKyx8p3C',
  'Nashville Predators': 'https://open.spotify.com/embed/playlist/0rkvtpnKGKVjfJmkhpYPpz',
  'Minnesota Wild': 'https://open.spotify.com/embed/playlist/5ZhcZQjW60N23IvWSaaQ0u',
  'Montreal Canadiens': 'https://open.spotify.com/embed/playlist/2FlmSUUbXRdzbWfru4gLxK',
  'Colorado Avalanche': 'https://open.spotify.com/embed/playlist/2GRK6uoVjcwEipJER3QKmf',
  'Dallas Stars': 'https://open.spotify.com/embed/playlist/2nTNmoWZIkbJC8caiLQvKq',
  'Detroit Red Wings': 'https://open.spotify.com/embed/playlist/0RNgYLnYCQOFciZBN3Ty95',
  'Detroit RedWings': 'https://open.spotify.com/embed/playlist/0RNgYLnYCQOFciZBN3Ty95',
  'Los Angeles Kings': 'https://open.spotify.com/embed/playlist/4nFeRBX5PgAFX539ICJM2d',
  'Columbus Blue Jackets': 'https://open.spotify.com/embed/playlist/6Sk9Hr0sqil086vyYu8Kol',
  'Edmonton Oilers': 'https://open.spotify.com/embed/playlist/4KG1JyCmELXdjexgPd96dL',
  'Boston Bruins': 'https://open.spotify.com/embed/playlist/7xsSvxvZxlVFxhWb26XkjQ',
  'Florida Panthers': 'https://open.spotify.com/embed/playlist/4zuDtxBx842xmNTmTnkqVV',
  'Carolina Hurricanes': 'https://open.spotify.com/embed/playlist/4qPrkV5fTcVQaDpDg0EEIx',
  'Calgary Flames': 'https://open.spotify.com/embed/playlist/6wO2NNChDBgvGY5GgroXTD',
  'Buffalo Sabres': 'https://open.spotify.com/embed/playlist/3hsDTsHWDou707jwCf4T9r',
  'Anaheim Ducks': 'https://open.spotify.com/embed/playlist/7J04oNb6fh7ewfNgopGiDv',
  'Utah Mammoth': 'https://open.spotify.com/embed/playlist/4iQwyshEJmgLNfCWeQnclL',

  // NBA
  'Cleveland Cavaliers': 'https://open.spotify.com/embed/playlist/791W89I4E6vik4u1kOxEQd',
  'Cleveland Cavs': 'https://open.spotify.com/embed/playlist/791W89I4E6vik4u1kOxEQd',
  'Washington Wizards': 'https://open.spotify.com/embed/playlist/52t9ryBweRI0BpLfXkucfH',
  'Charlotte Hornets': 'https://open.spotify.com/embed/playlist/3dpERYWBIOm3zf2OYyodKe',
  'Charolette Hornets': 'https://open.spotify.com/embed/playlist/3dpERYWBIOm3zf2OYyodKe',
  'Milwaukee Bucks': 'https://open.spotify.com/embed/playlist/0zHhEve1DiLNpXJcMoU2sZ',
  'Indiana Pacers': 'https://open.spotify.com/embed/playlist/7f9nkJFu8eHPioAYy9xQGL',
  'Detroit Pistons': 'https://open.spotify.com/embed/playlist/0dQEADRp5nUwu2fnQBXSpK',
  'Philadelphia 76ers': 'https://open.spotify.com/embed/playlist/25jD01P0Oq29MFxjKXpmvb',
  'Miami Heat': 'https://open.spotify.com/embed/playlist/73gl3Ctk99KxKex6kteHun',
  'Minnesota Timberwolves': 'https://open.spotify.com/embed/playlist/1oWnnKuxt1W3hh8kJSx6Jc',
  'New Orleans Pelicans': 'https://open.spotify.com/embed/playlist/5e5GrDE5jtpuO48D9lVLdn',
  'Sacramento Kings': 'https://open.spotify.com/embed/playlist/3FkOsMB5AYA6TpRFwt7vuj',
  'Boston Celtics': 'https://open.spotify.com/embed/playlist/6sVNPgMvBNUVbqTiLAGe9j',
  'Toronto Raptors': 'https://open.spotify.com/embed/playlist/3Al6nfuXKKd0EH5myTSzRQ',
  'Portland Trail Blazers': 'https://open.spotify.com/embed/playlist/2o3XiVFkINBsM7Fg5apZIO',
  'Dallas Mavericks': 'https://open.spotify.com/embed/playlist/71abp0pFGtZELM1X0w7yY5',
  'Houston Rockets': 'https://open.spotify.com/embed/playlist/6Cl1Uffbla0yA46wOWE2AH',
  'San Antonio Spurs': 'https://open.spotify.com/embed/playlist/3UMShWL0VLBiZzGSILXQyj',
  'Phoenix Suns': 'https://open.spotify.com/embed/playlist/06xnbqtXWiVxFISuTXnnWA',
  'Memphis Grizzlies': 'https://open.spotify.com/embed/playlist/2cC257g3jDgCWd3ljL8CmI',
  'Utah Jazz': 'https://open.spotify.com/embed/playlist/39NAP4tFF24BYPihly1Jsu',
  'Denver Nuggets': 'https://open.spotify.com/embed/playlist/1hEOdVVcmNLbdmONodwmWT',
  'Golden State Warriors': 'https://open.spotify.com/embed/playlist/6DGYnWEqtnc6grz2mm5QiH',
  'LA Clippers': 'https://open.spotify.com/embed/playlist/23IrWQnundM9TjUa0f057i',
  'Los Angeles Clippers': 'https://open.spotify.com/embed/playlist/23IrWQnundM9TjUa0f057i',
  'LA Lakers': 'https://open.spotify.com/embed/playlist/5BZUopZ8lKlLofuJmjtJUP',
  'Los Angeles Lakers': 'https://open.spotify.com/embed/playlist/5BZUopZ8lKlLofuJmjtJUP',
  'Brooklyn Nets': 'https://open.spotify.com/embed/playlist/73EeISZ2UaimnScEz7bo4V',
  'New York Knicks': 'https://open.spotify.com/embed/playlist/6M91lhhLv211OqLNPSdRY4',
  'Chicago Bulls': 'https://open.spotify.com/embed/playlist/0I1syQB9OeJc4Yj9IgJU7x',
  'Orlando Magic': 'https://open.spotify.com/embed/playlist/1umRCPrrFUfrq9UKlDNZLR',
  'Atlanta Hawks': 'https://open.spotify.com/embed/playlist/3wlYW48eqdl0O9CQen1lhD',
  'OKC Thunder': 'https://open.spotify.com/embed/playlist/52jXbzD5kfYXWFIbmVSL2X',
  'Oklahoma City Thunder': 'https://open.spotify.com/embed/playlist/52jXbzD5kfYXWFIbmVSL2X',
};

export const getPlaylistForTeam = (teamName) => {
  if (!teamName) return undefined;
  return playlistLinks[teamName] || undefined;
};


